export default "__VITE_ASSET__C2Z4Onpq__"